import { Component, lazy, Suspense, useEffect, useState } from 'react';
import { ARCHIVE_VIEWER_EVENT } from '../../services/archiveService';

// Erst bei Bedarf laden (PDF.js ist groß); liegt trotzdem im Offline-Cache der App
const ArchiveViewer = lazy(() => import('./ArchiveViewer'));

/** Ein Fehler in der Ansicht darf nie die App mitreißen – dann einfach schließen */
class ViewerBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) {
    console.error('Archiv-Ansicht:', error);
    this.props.onClose();
  }
  render() { return this.state.failed ? null : this.props.children; }
}

/** Zeigt Archiv-Dokumente in der App an, wenn openArchiveDocument() das anfordert */
export default function ArchiveViewerHost() {
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    const open = (event) => setCurrent({ ...event.detail, key: Date.now() });
    window.addEventListener(ARCHIVE_VIEWER_EVENT, open);
    return () => window.removeEventListener(ARCHIVE_VIEWER_EVENT, open);
  }, []);

  if (!current?.docId) return null;
  return (
    <ViewerBoundary key={current.key} onClose={() => setCurrent(null)}>
      <Suspense fallback={null}>
        <ArchiveViewer docId={current.docId} title={current.title} onClose={() => setCurrent(null)} />
      </Suspense>
    </ViewerBoundary>
  );
}
